// extracted by mini-css-extract-plugin
module.exports = {"loaderBackground":"LoaderContainer_loaderBackground__1irQ_","loading-text":"LoaderContainer_loading-text__1SobD"};